import {
  AfterContentInit,
  Component,
  ContentChildren,
  HostBinding,
  Input,
  OnChanges,
  Optional,
  QueryList,
  Self,
  SimpleChanges,
  SkipSelf,
  TemplateRef
} from '@angular/core';
import { AvanoButtonBarButtonDetails } from '../avano-button-bar/avano-button-bar.common';
import { AvanoButtonBarService } from '../avano-button-bar/avano-button-bar.service';
import { ValidationErrorsService } from '../avano-validation/validation-errors-service';
import { AvanoTemplate } from '../directives/avano-template.directive';

@Component({
  selector: 'avano-panel',
  templateUrl: './avano-panel.component.html',
  styleUrls: ['./avano-panel.component.scss'],
  providers: [AvanoButtonBarService]
})
export class AvanoPanelComponent implements AfterContentInit, OnChanges {
  @Input() collapsed: boolean;
  @Input() isCollapsable: boolean;
  @Input() isMaximizable: boolean;
  @Input() @HostBinding('class.branded') isCallToAction = false;
  @Input() noPadding: boolean;
  @Input() headerText: string;
  @Input() headerSubheading: string;
  @Input() headerIcon: string;

  @HostBinding('class.avano-panel-maximized') maximized: boolean;
  @HostBinding(`attr.${ValidationErrorsService.attributeName}`) validationBreadcrumb: string;

  @ContentChildren(AvanoTemplate) templates: QueryList<any>;

  summaryTemplate: TemplateRef<any>;
  areaActionsTemplate: TemplateRef<any>;
  contentActionsTemplate: TemplateRef<any>;
  footerTemplate: TemplateRef<any>;

  childrenContentActions: AvanoButtonBarButtonDetails[] = [];

  constructor(
    @Optional() @SkipSelf() parentButtonBarService: AvanoButtonBarService,
    @Self() childrensButtonBarService: AvanoButtonBarService
  ) {
    this.initContentActionsInterceptor(parentButtonBarService, childrensButtonBarService);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.headerText) {
      this.validationBreadcrumb = changes.headerText.currentValue;
    }
  }

  public collapsePanel() {
    if (this.isCollapsable && !this.maximized) {
      this.collapsed = !this.collapsed;
    }
  }

  public toggleMaximization() {
    if (this.isMaximizable) {
      this.maximized = !this.maximized;
      this.collapsed = false;
    }
  }

  // The whole header is clickable for collapsing, but when an icon is clicked
  // we do not want the click to bubble, so lets catch it always.
  public preventCollapse(event): void {
    event.preventDefault();
    event.stopPropagation();
  }

  ngAfterContentInit() {
    this.templates.forEach((item) => {
      switch(item.getType()) {
        case 'areaactions':
          this.areaActionsTemplate = item.template;
          break;
        case 'summary':
          this.summaryTemplate = item.template;
          break;
        case 'contentactions':
          this.contentActionsTemplate = item.template;
          break;
        case 'footer':
          this.footerTemplate = item.template;
          break;
      }
    });
  }

  private initContentActionsInterceptor(parentButtonBarService: AvanoButtonBarService, childrensButtonBarService: AvanoButtonBarService) {
    childrensButtonBarService.buttonBarDetails$.subscribe({next: (childrenContentActions) => {
      if (childrenContentActions?.length >= 0) {
        this.childrenContentActions = childrenContentActions;
        if (parentButtonBarService) {
          parentButtonBarService.addOrUpdate(childrenContentActions)
        }
      }
    }})
  }
}
